var exports = {
  "x6": "DownloadButton.module__button___bTlZUl",
  "td": "DownloadButton.module__iconText___bTlZUl",
  "ro": "DownloadButton.module__menuIcon___bTlZUl",
};

module.exports = exports;
